import { FC } from 'react';
import {
  Button,
  Flex,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';

type Props = {
  folderName: string;
  onCancel: () => void;
  suggestedFolderName: string;
  onConfirm: (suggestedFilename: string) => void;
};

export const CreateFolderValidationDialog: FC<Props> = ({
  onCancel,
  onConfirm,
  folderName,
  suggestedFolderName,
}) => {
  const handleConfirm = () => {
    onConfirm(suggestedFolderName);
  };

  return (
    <ModalContent data-testid="folder-validation-confirmation">
      <ModalHeader fontSize="lg" fontWeight="bold">
        Confirm changes?
      </ModalHeader>
      <ModalBody>
        <Flex direction="column" gridGap="6" data-testid="validation-message">
          <Text as="span">
            Folder name{' '}
            <Text as="span" fontWeight="bold">
              "{folderName}"
            </Text>{' '}
            is invalid, would you like to rename it to{' '}
            <Text as="span" fontWeight="bold">
              "{suggestedFolderName}"
            </Text>
            ?
          </Text>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel} data-testid="cancel">
          Cancel
        </Button>
        <Button
          ml={3}
          colorScheme="green"
          onClick={handleConfirm}
          data-testid="confirm"
        >
          Rename & Create
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
